// extracted by mini-css-extract-plugin
export var fadeInOut = "_42-3";
export var icon = "_42-4";
export var savedIndicator = "_42-2";
export var savingIndicator = "_42-0";
export var spin = "_42-1";